import YesNo from './YesNo.jsx';
import SingleSelect from './SingleSelect.jsx';
import MultiSelect from './MultiSelect.jsx';
import SupplementPicker from './SupplementPicker.jsx';
import { TextInput, NumberInput, HeightInput, DateInput, FieldsInput, EmailInput } from './inputs.jsx';

const BY_TYPE = {
  yn: YesNo,
  single: SingleSelect,
  multi: MultiSelect,
  supps: SupplementPicker,
  text: TextInput,
  num: NumberInput,
  height: HeightInput,
  date: DateInput,
  fields: FieldsInput,
  email: EmailInput,
};

// Dispatch a config item to its input component. Every component takes the same
// props: (item, answers, setAnswer, onAdvance).
export default function QuestionRenderer(props) {
  const Comp = BY_TYPE[props.item.type] || TextInput;
  return <Comp {...props} />;
}
